import { render, staticRenderFns } from "./Triangle.vue?vue&type=template&id=bd399398&scoped=true&"
import script from "./Triangle.vue?vue&type=script&lang=js&"
export * from "./Triangle.vue?vue&type=script&lang=js&"
import style0 from "./Triangle.vue?vue&type=style&index=0&id=bd399398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd399398",
  null
  
)

export default component.exports